var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopLogoEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 47,
    viewBox: "0 0 159 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83762 34.2051V12.7949H0V34.2117H5.83762V34.2051ZM36.6373 34.2051V12.7949H31.4349L24.7949 23.6183H24.728L18.0545 12.7949H12.7184V34.2117H18.4223V23.914H18.5895L23.5645 31.8853H25.6307L30.599 23.914H30.7662V34.2117H36.6373V34.2051ZM57.0255 20.9896H49.349V17.6118H62.1276V12.7883H43.5047V34.2051H62.8564V29.3816H49.3423V25.6095H57.0188V20.9831L57.0255 20.9896ZM77.8818 34.2051C82.1881 34.2051 84.923 32.9894 86.8221 31.1559C88.8282 29.2173 89.8914 26.4638 89.8914 23.4803C89.8914 20.4968 88.8549 17.9404 86.9893 16.0018C84.9498 13.9055 81.9541 12.7883 77.8818 12.7883H67.8381V34.2051H77.8818ZM73.6758 29.3881V17.6184H77.748C80.1486 17.6184 81.2854 18.2099 82.255 19.2219C83.2915 20.3062 83.8531 21.6797 83.8531 23.5526C83.8531 25.5503 83.2179 26.8975 82.0811 27.9818C81.1115 28.9018 79.9815 29.3881 77.7414 29.3881H73.6691H73.6758ZM100.971 34.2051V12.7949H95.1339V34.2117H100.971V34.2051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.799 13.4849V32.7265H144.075V28.3958H133.055V13.4849H127.799ZM135.088 0C141.688 0 147.666 2.62864 151.992 6.88045C156.318 11.1323 158.993 17.0073 158.993 23.4934C158.993 29.9796 156.318 35.8612 151.992 40.113C147.666 44.3648 141.688 47 135.088 47C128.488 47 122.503 44.3714 118.183 40.113C113.857 35.8612 111.182 29.9862 111.182 23.4934C111.182 17.0007 113.857 11.1323 118.183 6.88045C122.51 2.62864 128.488 0 135.088 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLogoEng);
export default __webpack_public_path__ + "static/media/desktop-logo-eng.aca5e0676bf8c49938ac0ef7ce11dcfc.svg";
export { ForwardRef as ReactComponent };